module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_1_3-3bec43e4ef58e8e7570a2d1c0fffd2b7.webp";